// The server's VAPID public key (GET /push/key) arrives as base64url text;
// pushManager.subscribe wants the raw bytes.

/** base64url (RFC 4648 §5, padding optional) → bytes. Throws on anything else. */
export function base64UrlToUint8Array(input: string): Uint8Array<ArrayBuffer> {
  const s = input.trim().replace(/=+$/, '');
  if (!/^[A-Za-z0-9_-]*$/.test(s)) throw new Error('The push key from the server is not base64url text.');
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - (s.length % 4)) % 4);
  let raw: string;
  try {
    raw = atob(b64);
  } catch {
    throw new Error('The push key from the server could not be decoded.');
  }
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

/** An uncompressed P-256 public key: 65 bytes starting with 0x04. An empty
 *  answer means the server has no key yet (VAPID secrets not set). */
export function isVapidPublicKey(bytes: Uint8Array): boolean {
  return bytes.length === 65 && bytes[0] === 0x04;
}

/**
 * Was this existing subscription made with `key`? A subscription made with an
 * older key cannot be reused — the browser refuses to subscribe again with a
 * different key until the old one is dropped.
 */
export function sameKey(existing: ArrayBuffer | null | undefined, key: Uint8Array): boolean {
  if (!existing) return false;
  const a = new Uint8Array(existing);
  if (a.length !== key.length) return false;
  for (let i = 0; i < a.length; i++) if (a[i] !== key[i]) return false;
  return true;
}
